(function () {
  var stickies = document.querySelectorAll('[data-sw-sticky-atc]');
  if (!stickies.length) return;

  for (var si = 0; si < stickies.length - 1; si++) {
    stickies[si].setAttribute('data-sw-sticky-atc-inactive', '');
  }

  var sticky = stickies[stickies.length - 1];
  var explicitHideZoneAttr = sticky.getAttribute('data-sw-sticky-hide-in-ids');
  explicitHideZoneAttr = explicitHideZoneAttr && typeof explicitHideZoneAttr === 'string' ? explicitHideZoneAttr.trim() : '';
  var hasExplicitHideZones = explicitHideZoneAttr !== '';

  function parseHideSectionIds(attr) {
    if (!attr || typeof attr !== 'string') return [];
    return attr.split(',').map(function (s) {
      s = s.trim();
      if (!s) return null;
      if (s.charAt(0) === '#') s = s.slice(1);
      return s;
    }).filter(Boolean);
  }

  /** Elements that suppress the sticky bar while intersecting the viewport (same rootMargin as observer). */
  function resolveHideZoneElements() {
    var raw = explicitHideZoneAttr;
    if (raw) {
      var ids = parseHideSectionIds(raw);
      var explicit = [];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el) explicit.push(el);
      }
      return explicit;
    }
    var pt = document.getElementById('productTop');
    if (pt) return [pt];
    var hero = document.getElementById('hero');
    if (hero) return [hero];
    var top = document.getElementById('top');
    if (top) return [top];
    var first = document.querySelector('#MainContent .shopify-section');
    if (first) return [first];
    var firstChild = document.querySelector('#MainContent > *');
    return firstChild ? [firstChild] : [];
  }

  var hideZoneEls = resolveHideZoneElements();
  hideZoneEls = (function dedupeDomNodes(arr) {
    var seen = new Set();
    var out = [];
    for (var d = 0; d < arr.length; d++) {
      if (!seen.has(arr[d])) {
        seen.add(arr[d]);
        out.push(arr[d]);
      }
    }
    return out;
  })(hideZoneEls);

  var productTop = document.getElementById('productTop');

  var stickyPrice = sticky.querySelector('[data-sw-sticky-price]');
  var stickyUnit = sticky.querySelector('[data-sw-sticky-unit]');
  var stickyTitle = sticky.querySelector('[data-sw-sticky-title]');
  var stickyVariant = sticky.querySelector('[data-sw-sticky-variant]');
  var stickyMobilePrice = sticky.querySelector('[data-sw-sticky-mobile-price-value]');
  var stickyMobileUnit = sticky.querySelector('[data-sw-sticky-mobile-unit]');
  var stickyShowVariantAsTitle = sticky.getAttribute('data-sw-sticky-show-variant-as-title') === 'true';
  var stickyProductTitle = sticky.getAttribute('data-sw-sticky-product-title') || '';

  var stickyUnitData = null;
  (function loadStickyUnitData() {
    var jsonEl = sticky.querySelector('[data-sw-sticky-unit-data]');
    if (!jsonEl) return;
    try {
      stickyUnitData = JSON.parse(jsonEl.textContent);
    } catch (_) {
      stickyUnitData = null;
    }
  })();

  function getCurrentVariantIdFromProduct() {
    if (!productTop) {
      return sticky.getAttribute('data-sw-sticky-variant-id') || '';
    }
    var info = productTop.querySelector('.product__info-container') || productTop;
    var idInput =
      info.querySelector('product-form form input[name="id"]') ||
      info.querySelector('form input[name="id"]') ||
      info.querySelector('input[name="id"]');
    return idInput && idInput.value ? String(idInput.value) : '';
  }

  function resolveStickyUnitText() {
    var variantId = getCurrentVariantIdFromProduct();
    if (variantId && stickyUnitData && stickyUnitData.units) {
      var mapped = stickyUnitData.units[variantId];
      if (mapped) return mapped;
    }

    if (!productTop) return '';

    var checkedInput =
      productTop.querySelector('[data-sw-vp-grid] .sw-vp__input:checked:not(:disabled)') ||
      productTop.querySelector('.sw-vp-chips .sw-vp__input:checked:not(:disabled)') ||
      productTop.querySelector('.sw-vp-rcards .sw-vp__input:checked:not(:disabled)');
    if (checkedInput) {
      var card = checkedInput.closest('.sw-vp__card, .sw-vp-chip, .sw-vp-rcard');
      var cardUnit = card && card.querySelector('.sw-vp__unit-price');
      if (cardUnit) return cardUnit.textContent.trim();
    }

    return '';
  }

  function syncStickyUnitText() {
    if (!stickyUnit) return;
    var unitText = resolveStickyUnitText();
    if (unitText) {
      stickyUnit.textContent = unitText;
      stickyUnit.hidden = false;
    } else {
      stickyUnit.textContent = '';
      stickyUnit.hidden = true;
    }
  }

  function wrapRoot() {
    if (!productTop) return null;
    return productTop.closest('.product__info-container') ||
      productTop.querySelector('.product__info-container') ||
      productTop;
  }

  function findSnippetPriceEl() {
    var w = wrapRoot();
    return w ? w.querySelector('[id^="price-"]') : null;
  }

  function getPriceModeFromDom() {
    if (!productTop) return 'subscription';
    var wm = productTop.querySelector('[data-sw-price-mode]');
    var raw = wm && wm.getAttribute('data-sw-price-mode');
    return raw === 'onetime' ? 'onetime' : 'subscription';
  }

  function findChipPriceRow(mode) {
    if (!productTop) return null;
    var chips = productTop.querySelector('.sw-vp-chips');
    if (!chips) return null;
    var input =
      chips.querySelector('.sw-vp__input:checked') || chips.querySelector('.sw-vp__input');
    if (!input) return null;
    var chip = input.closest('.sw-vp-chip');
    if (!chip) return null;
    var sel = '.sw-vp-chip__price-row--' + (mode === 'onetime' ? 'onetime' : 'subscription');
    return chip.querySelector(sel) || chip.querySelector('.sw-vp-chip__price-row');
  }

  function findRcardPriceRow(mode) {
    if (!productTop) return null;
    var rcards = productTop.querySelector('.sw-vp-rcards');
    if (!rcards) return null;
    var input = rcards.querySelector('.sw-vp__input:checked') || rcards.querySelector('.sw-vp__input');
    if (!input) return null;
    var card = input.closest('.sw-vp-rcard');
    if (!card) return null;
    return (
      card.querySelector('.sw-vp-rcard__pricing-row.sw-vp-rcard__pricing--' + mode) ||
      card.querySelector('.sw-vp-rcard__pricing-row')
    );
  }

  function findChipListedPrice(mode) {
    var row = findChipPriceRow(mode);
    return row ? row.querySelector('.sw-vp-chip__price') : null;
  }

  function findRcardListedPrice(mode) {
    var row = findRcardPriceRow(mode);
    return row ? row.querySelector('.sw-vp-rcard__price') : null;
  }

  function resolveStickyListedPrice(mode) {
    mode = mode || getPriceModeFromDom();

    var priceEl = findSnippetPriceEl();
    if (priceEl) {
      var saleEl = priceEl.querySelector('.price-item--sale');
      var regularEl = priceEl.querySelector('.price-item--regular');
      var activeEl = saleEl || regularEl;
      if (activeEl && activeEl.textContent.trim()) return activeEl.textContent.trim();
    }

    var chipPrice = findChipListedPrice(mode);
    if (chipPrice && chipPrice.textContent.trim()) return chipPrice.textContent.trim();

    var rcardPrice = findRcardListedPrice(mode);
    if (rcardPrice && rcardPrice.textContent.trim()) return rcardPrice.textContent.trim();

    var variantId = getCurrentVariantIdFromProduct();
    if (variantId && stickyUnitData && stickyUnitData.prices) {
      var mapped = stickyUnitData.prices[variantId];
      if (mapped) {
        var modePrice = mapped[mode] || mapped.onetime || mapped.subscription;
        if (modePrice) return modePrice;
      }
    }

    if (stickyPrice && stickyPrice.textContent.trim()) return stickyPrice.textContent.trim();
    if (stickyMobilePrice && stickyMobilePrice.textContent.trim()) return stickyMobilePrice.textContent.trim();
    return '';
  }

  function syncStickyMobilePrice(mode) {
    if (!stickyMobilePrice) return;
    var priceText = resolveStickyListedPrice(mode);
    if (priceText) stickyMobilePrice.textContent = priceText;
  }

  /** Full variant title from variant-radios JSON + form id (works for grid / chips / rcards). */
  function resolveVariantTitleFromProduct() {
    if (!productTop) return '';
    var info = productTop.querySelector('.product__info-container') || productTop;
    var vr = info.querySelector('variant-radios') || info.querySelector('variant-selects');
    if (vr) {
      var jsonEl = vr.querySelector('[type="application/json"]');
      if (jsonEl) {
        var variants;
        try {
          variants = JSON.parse(jsonEl.textContent);
        } catch (_) {
          variants = null;
        }
        if (variants && variants.length) {
          var idInput =
            info.querySelector('product-form form input[name="id"]') ||
            info.querySelector('form input[name="id"]') ||
            info.querySelector('input[name="id"]');
          if (idInput && idInput.value) {
            var match = variants.find(function (v) {
              return String(v.id) === String(idInput.value);
            });
            if (match && match.title) return match.title;
          }
        }
      }
    }
    var host =
      productTop.querySelector('.sw-vp-rcards') ||
      productTop.querySelector('.sw-vp-chips') ||
      productTop.querySelector('[data-sw-vp-grid]');
    if (!host) return '';
    var input =
      host.querySelector('.sw-vp__input:checked') || host.querySelector('.sw-vp__input');
    var wrap =
      input &&
      (input.closest('.sw-vp-rcard') ||
        input.closest('.sw-vp-chip') ||
        input.closest('.sw-vp__card'));
    var ttl =
      wrap &&
      (wrap.querySelector('.sw-vp-rcard__title') ||
        wrap.querySelector('.sw-vp-chip__title') ||
        wrap.querySelector('.sw-vp__weight'));
    return ttl ? ttl.textContent.trim() : '';
  }

  function syncStickyTitleAndSubtitle() {
    var variantName = resolveVariantTitleFromProduct();
    if (!variantName && stickyVariant) {
      variantName = stickyVariant.textContent.trim();
    }

    if (stickyVariant && variantName) {
      stickyVariant.textContent = variantName;
    }

    if (stickyTitle) {
      if (stickyShowVariantAsTitle) {
        stickyTitle.textContent = variantName;
        if (stickyVariant) stickyVariant.hidden = true;
      } else {
        stickyTitle.textContent = stickyProductTitle;
        if (stickyVariant) {
          stickyVariant.textContent = variantName;
          stickyVariant.hidden = !variantName;
        }
      }
    }

    syncStickyMobilePrice(getPriceModeFromDom());

    if (stickyMobileUnit && stickyUnit) {
      if (stickyUnit.hidden || !stickyUnit.textContent.trim()) {
        stickyMobileUnit.textContent = '';
        stickyMobileUnit.hidden = true;
      } else {
        stickyMobileUnit.textContent = stickyUnit.textContent.trim();
        stickyMobileUnit.hidden = false;
      }
    }
  }

  function syncStickyVariantText() {
    syncStickyTitleAndSubtitle();
  }

  function syncPrice() {
    if (stickyUnit) syncStickyUnitText();
    var mode = getPriceModeFromDom();
    var priceText = resolveStickyListedPrice(mode);

    if (stickyPrice && priceText) {
      stickyPrice.textContent = priceText;
    }

    syncStickyVariantText();
  }

  document.addEventListener('sw:sticky-atc-sync', function () {
    syncPrice();
  });

  window.addEventListener(
    'resize',
    function () {
      syncStickyTitleAndSubtitle();
    },
    { passive: true }
  );

  var hideZoneState = new Map();
  function applyStickyVisibilityFromHideZones() {
    if (!hasExplicitHideZones && hideZoneEls.length) {
      sticky.hidden = hideZoneEls[0].getBoundingClientRect().top > 48;
      return;
    }

    var any = false;
    hideZoneState.forEach(function (v) {
      if (v) any = true;
    });
    sticky.hidden = any;
  }

  if (hideZoneEls.length) {
    hideZoneEls.forEach(function (el) {
      hideZoneState.set(el, false);
    });
    var hideZoneObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          hideZoneState.set(entry.target, entry.isIntersecting);
        });
        applyStickyVisibilityFromHideZones();
      },
      { rootMargin: '-48px 0px 0px 0px', threshold: 0 }
    );
    hideZoneEls.forEach(function (el) {
      hideZoneObserver.observe(el);
    });
    applyStickyVisibilityFromHideZones();

    if (!hasExplicitHideZones) {
      var visibilityFrame = null;
      var scheduleVisibilityUpdate = function () {
        if (visibilityFrame) return;
        visibilityFrame = window.requestAnimationFrame(function () {
          visibilityFrame = null;
          applyStickyVisibilityFromHideZones();
        });
      };
      window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
      window.addEventListener('resize', scheduleVisibilityUpdate);
    }
  } else {
    sticky.hidden = false;
  }

  syncPrice();

  if (productTop) {
    var subtreeMo = new MutationObserver(syncPrice);
    subtreeMo.observe(productTop, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-sw-price-mode', 'hidden']
    });

    var priceSnippetMoEl = findSnippetPriceEl();
    if (priceSnippetMoEl && stickyPrice) {
      var priceSnippetMo = new MutationObserver(syncPrice);
      priceSnippetMo.observe(priceSnippetMoEl, { childList: true, subtree: true, characterData: true });
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !productTop) return;
    if (e.target.name === 'id' && e.target.closest('.product__info-container')) {
      window.setTimeout(syncPrice, 400);
    }
    if (e.target.classList && e.target.classList.contains('sw-vp__input') && productTop.contains(e.target)) {
      window.setTimeout(syncPrice, 120);
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      if (!productTop) return;
      var tab = e.target && e.target.closest && e.target.closest('.sw-purchase-tab[data-tab]');
      if (tab && productTop.contains(tab)) {
        window.setTimeout(syncPrice, 160);
      }
    },
    true
  );
})();

(function () {
  function variantTitleForContainer(container) {
    if (!container) return '';
    var input =
      container.querySelector('.sw-vp-rcards .sw-vp__input:checked:not(:disabled)') ||
      container.querySelector('.sw-vp-chips .sw-vp__input:checked:not(:disabled)') ||
      container.querySelector('[data-sw-vp-grid] .sw-vp__input:checked:not(:disabled)');
    if (input) {
      var wrap = input.closest('.sw-vp-rcard, .sw-vp-chip, .sw-vp__card');
      var ttl =
        wrap &&
        (wrap.querySelector('.sw-vp-rcard__title') ||
          wrap.querySelector('.sw-vp-chip__title') ||
          wrap.querySelector('.sw-vp__weight'));
      if (ttl) return ttl.textContent.trim();
    }
    var variantSwitcher =
      container.querySelector('variant-radios') || container.querySelector('variant-selects');
    if (!variantSwitcher) return '';
    var jsonEl = variantSwitcher.querySelector('[type="application/json"]');
    if (!jsonEl) return '';
    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (_) {
      return '';
    }
    var idInput =
      container.querySelector('product-form form input[name="id"]') ||
      container.querySelector('form input[name="id"]');
    if (!idInput || !idInput.value || !variants) return '';
    var match = variants.find(function (v) {
      return String(v.id) === String(idInput.value);
    });
    return match && match.title ? match.title : '';
  }

  function syncAtcVariantLabels(container) {
    if (!container) return;
    var mirror = container.querySelector('[data-sw-atc-mirror-rcard]');
    if (mirror) {
      var input = container.querySelector('.sw-vp-rcards .sw-vp__input:checked:not(:disabled)');
      var cta =
        input &&
        input.closest('.sw-vp-rcard') &&
        input.closest('.sw-vp-rcard').querySelector('.sw-vp-rcard__cta');
      if (cta) mirror.textContent = cta.textContent.trim();
      return;
    }
    var title = variantTitleForContainer(container);
    if (!title) return;
    container.querySelectorAll('[data-sw-atc-variant]').forEach(function (el) {
      el.textContent = title;
    });
    var activeSticky = document.querySelector('[data-sw-sticky-atc]:not([data-sw-sticky-atc-inactive])');
    if (activeSticky) {
      document.dispatchEvent(new CustomEvent('sw:sticky-atc-sync'));
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    var container = null;
    if (e.target.name === 'id') {
      container = e.target.closest('.product__info-container');
    } else if (e.target.classList && e.target.classList.contains('sw-vp__input')) {
      if (!e.target.checked) return;
      container = e.target.closest('.product__info-container');
    }
    if (container) syncAtcVariantLabels(container);
  });

  function initAtcVariantLabels() {
    document.querySelectorAll('.product__info-container').forEach(syncAtcVariantLabels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAtcVariantLabels);
  } else {
    initAtcVariantLabels();
  }
})();

(function () {
  var ATTR_SKIP_BROWSER = 'data-sw-skip-browser-product-url';

  function sectionSkipsBrowserUrl(sectionId) {
    if (!sectionId) return false;
    var root = document.getElementById('ProductInfo-' + sectionId);
    return !!(root && root.getAttribute(ATTR_SKIP_BROWSER) === 'true');
  }

  function applySellingPlanParamsToLocation(planId, sectionId) {
    if (sectionSkipsBrowserUrl(sectionId)) return;
    var params = new URLSearchParams(window.location.search);
    if (planId) {
      params.set('selling_plan', planId);
    } else {
      params.delete('selling_plan');
    }
    var qs = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
  }

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.name !== 'id' || !e.target.closest('.product__info-container')) return;
    var sectionEl = e.target.closest('[id^="ProductInfo-"]');
    if (!sectionEl) return;
    var sectionId = sectionEl.id.replace('ProductInfo-', '');
    var mapEl = document.getElementById('sw-selling-plans-' + sectionId);
    if (!mapEl) return;
    var plans;
    try { plans = JSON.parse(mapEl.textContent); } catch (_) { return; }
    var tabsEl = sectionEl.querySelector('[data-sw-purchase-tabs][data-section="' + sectionId + '"]');
    var activeTab = tabsEl && tabsEl.querySelector('.sw-purchase-tab--active');
    var isSubscription = !tabsEl || (activeTab && activeTab.dataset.tab === 'subscription');
    var planId = isSubscription ? (plans[e.target.value] || '') : '';
    var hiddenInputId = 'sw-selling-plan-input-' + sectionId;
    window.setTimeout(function () {
      applySellingPlanParamsToLocation(planId, sectionId);
      var hiddenInput = document.getElementById(hiddenInputId);
      if (hiddenInput) hiddenInput.value = planId;
    }, 0);
  });

  function onPurchaseTabPointer(e) {
    var btn =
      e.target && e.target.closest && e.target.closest('.sw-purchase-tab[data-tab]');
    if (!btn) return;
    var tabs = btn.closest('[data-sw-purchase-tabs]');
    if (!tabs) return;
    var sectionId = tabs.dataset.section;
    var infoRoot = tabs.closest('.product__info-container');

    tabs.querySelectorAll('.sw-purchase-tab').forEach(function (t) {
      t.classList.remove('sw-purchase-tab--active');
    });
    btn.classList.add('sw-purchase-tab--active');

    var activeTab = btn.dataset.tab;
    var scope = infoRoot || document;
    scope.querySelectorAll('[data-sw-purchase-info]').forEach(function (el) {
      el.classList.toggle('sw-purchase-info--hidden', el.dataset.swPurchaseInfo !== activeTab);
    });
    scope.querySelectorAll('[data-sw-price-mode]').forEach(function (el) {
      el.dataset.swPriceMode = activeTab;
    });

    var planId = '';
    if (btn.dataset.tab === 'subscription') {
      var mapEl = document.getElementById('sw-selling-plans-' + sectionId);
      if (mapEl) {
        var plans;
        try { plans = JSON.parse(mapEl.textContent); } catch (_) {}
        if (plans && infoRoot) {
          var variantInput = infoRoot.querySelector(
            '#product-form-embed-' + sectionId + ' input[name="id"], ' +
              '#product-form-' + sectionId + ' input[name="id"]'
          );
          if (variantInput) planId = plans[variantInput.value] || '';
        }
      }
    }

    applySellingPlanParamsToLocation(planId, sectionId);
    var hiddenInput = document.getElementById('sw-selling-plan-input-' + sectionId);
    if (hiddenInput) hiddenInput.value = planId;

    var vr =
      infoRoot &&
      infoRoot.querySelector('variant-radios[data-section="' + sectionId + '"]');
    if (vr && typeof vr.onVariantChange === 'function') {
      try {
        vr.onVariantChange();
      } catch (err) {}
    }
  }

  document.addEventListener('click', onPurchaseTabPointer, true);

  document.querySelectorAll('[id^="sw-selling-plan-input-"]').forEach(function (input) {
    var sid = input.id.replace('sw-selling-plan-input-', '');
    if (!input.value || sectionSkipsBrowserUrl(sid)) return;
    applySellingPlanParamsToLocation(input.value, sid);
  });
})();

/** Sticky ATC: submit the main #productTop product form (variant, qty, selling plan) — same as primary ATC */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-sw-sticky-atc-submit]');
    if (!btn) return;
    e.preventDefault();

    var sticky = btn.closest('[data-sw-sticky-atc]');
    if (!sticky) return;

    if (sticky.getAttribute('data-sw-sticky-behavior') === 'cta') return;

    var productTopEl = document.getElementById('productTop');
    var directCheckout = sticky.getAttribute('data-sw-direct-checkout') === 'true';
    var formEl = productTopEl && productTopEl.querySelector('product-form form');

    if (!formEl) {
      var vidStandalone = sticky.getAttribute('data-sw-sticky-variant-id');
      if (
        vidStandalone &&
        typeof fetchConfig === 'function' &&
        window.routes &&
        window.routes.cart_add_url
      ) {
        var spd = sticky.getAttribute('data-sw-sticky-selling-plan');
        spd = spd && spd.trim ? spd.trim() : '';
        var configStandalone = fetchConfig('javascript');
        configStandalone.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete configStandalone.headers['Content-Type'];

        var fdStandalone = new FormData();
        fdStandalone.append('id', vidStandalone);
        fdStandalone.append('quantity', '1');
        if (spd) fdStandalone.append('selling_plan', spd);

        var cnStandalone = document.querySelector('cart-notification');
        if (!directCheckout && cnStandalone && typeof cnStandalone.getSectionsToRender === 'function') {
          fdStandalone.append('sections', cnStandalone.getSectionsToRender().map(function (s) { return s.id; }));
          fdStandalone.append('sections_url', window.location.pathname);
        }

        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');

        fetch(window.routes.cart_add_url, Object.assign(configStandalone, { body: fdStandalone }))
          .then(function (r) {
            return r.json();
          })
          .then(function (response) {
            if (response.status) {
              window.alert(response.description || response.message || '');
              return;
            }

            document.dispatchEvent(new CustomEvent('cart:updated'));

            if (directCheckout) {
              var nextCheckout =
                (typeof window.routes !== 'undefined' && window.routes.checkout_url) || '/checkout';
              window.location.assign(nextCheckout);
              return;
            }

            if (window.swCartDrawer && typeof window.swCartDrawer.open === 'function') {
              window.swCartDrawer.open();
            }
          })
          .catch(function (err) {
            console.error(err);
          })
          .finally(function () {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          });
        return;
      }

      var fb = sticky.getAttribute('data-sw-fallback-href');
      if (fb && fb.trim()) window.location.href = fb.trim();
      return;
    }

    if (typeof fetchConfig !== 'function' || !window.routes || !window.routes.cart_add_url) return;

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var fd = new FormData(formEl);
    var cn = document.querySelector('cart-notification');
    if (!directCheckout && cn && typeof cn.getSectionsToRender === 'function') {
      fd.append('sections', cn.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }

    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');

    fetch(window.routes.cart_add_url, Object.assign(config, { body: fd }))
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          window.alert(response.description || response.message || '');
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));

        if (directCheckout) {
          var next =
            (typeof window.routes !== 'undefined' && window.routes.checkout_url) || '/checkout';
          window.location.assign(next);
          return;
        }

        if (window.swCartDrawer && typeof window.swCartDrawer.open === 'function') {
          window.swCartDrawer.open();
        }
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  });

  function initVariantPickersFromCheckedState() {
    document.querySelectorAll('variant-radios.sw-vp').forEach(function (vr) {
      var checked = vr.querySelector('input.sw-vp__input:checked:not(:disabled)');
      if (!checked) return;
      checked.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.querySelectorAll('.product__info-container').forEach(function (container) {
      var mirror = container.querySelector('[data-sw-atc-mirror-rcard]');
      if (mirror) {
        syncAtcVariantLabels(container);
        return;
      }
      var labels = container.querySelectorAll('[data-sw-atc-variant]');
      if (!labels.length) return;
      var input =
        container.querySelector('.sw-vp-rcards .sw-vp__input:checked:not(:disabled)') ||
        container.querySelector('.sw-vp-chips .sw-vp__input:checked:not(:disabled)') ||
        container.querySelector('[data-sw-vp-grid] .sw-vp__input:checked:not(:disabled)');
      if (!input) return;
      var wrap = input.closest('.sw-vp-rcard, .sw-vp-chip, .sw-vp__card');
      var ttl =
        wrap &&
        (wrap.querySelector('.sw-vp-rcard__title') ||
          wrap.querySelector('.sw-vp-chip__title') ||
          wrap.querySelector('.sw-vp__weight'));
      if (!ttl) return;
      var title = ttl.textContent.trim();
      labels.forEach(function (el) {
        el.textContent = title;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPickersFromCheckedState);
  } else {
    initVariantPickersFromCheckedState();
  }
})();
